import { TechDataVariations } from '@/types/types';

function hasProperty(variations: TechDataVariations, property: string) {
  return variations.variations.some((e) => property in e);
}

export function getVehicleType(variations: TechDataVariations) {
  if (hasProperty(variations, 'engineTypes')) {
    return 'Citan';
  }
  if (hasProperty(variations, 'weightsMax')) {
    return 'Vito';
  }
  if (hasProperty(variations, 'cabinTypes')) {
    return 'Sprinter_Cabin';
  }
  if (hasProperty(variations, 'roofHeightTypes')) {
    return 'Sprinter_Roof';
  }
}
